import { render, staticRenderFns } from "./r-swamp-dialog.vue?vue&type=template&id=3ffc2655"
import script from "./r-swamp-dialog.vue?vue&type=script&lang=js"
export * from "./r-swamp-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ffc2655')) {
      api.createRecord('3ffc2655', component.options)
    } else {
      api.reload('3ffc2655', component.options)
    }
    module.hot.accept("./r-swamp-dialog.vue?vue&type=template&id=3ffc2655", function () {
      api.rerender('3ffc2655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/world-biomes/swamp/r-swamp-dialog.vue"
export default component.exports